<template>
  <span>
    <v-row>
      <v-col cols="12" md="7">
        <v-form @submit.prevent="searchPostCode">
          <v-text-field autofocus hide-details dense label="Post code" outlined v-model="postcode" :disabled="postCodeSearchLoading||disabled">
            <v-icon slot="append" color="secondary" class="postcode-icon" v-if="(postcode!=='')" @click="searchPostCode">search</v-icon>
          </v-text-field>
        </v-form>
      </v-col>
      <v-col cols="12" md="5">
        <v-switch hide-details label="Enter Manually" class="mt-1" v-model="manualAddress" :disabled="disabled"></v-switch>
      </v-col>
    </v-row>
    <template v-if="searched&&addressOptions.length===0">
      <v-row>
        <v-col>
          No addresses found.
        </v-col>
      </v-row>
    </template>
    <template v-if="!manualAddress">
      <v-row>
        <v-col cols="12">
          <v-select hide-details dense label="Address" outlined :items="addressOptions" v-model="selectedAddressId" v-if="(addressOptions.length!==0 || postCodeSearchLoading)" :loading="postCodeSearchLoading" :disabled="postCodeSearchLoading||disabled"></v-select>
        </v-col>
      </v-row>
    </template>
    <template v-if="manualAddress">
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.line_one" hide-details dense label="Address line one" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.line_two" hide-details dense label="Address line two" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.city" hide-details dense label="City" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.county" hide-details dense label="County" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.post_code" hide-details dense label="Postcode" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="selectedAddress.country" hide-details dense label="Country" outlined @change="checkManualAddress" :disabled="disabled"></v-text-field>
        </v-col>
      </v-row>
    </template>
  </span>
</template>

<script>
  import { mapState,mapActions } from "vuex";

  export default {
    data() {
      return {
        searched: false,
        postCodeSearchLoading: false,
        postcode: '',
        manualAddress: false,
        addressOptions: [],
        selectedAddressId: '',
        selectedAddress: {
          line_one: '',
          line_two: '',
          city: '',
          county: '',
          post_code: '',
          country: 'United Kingdom',
        },
        allAddresses: [],
      }
    },
    props: {
      passedAddress: {
        type: Object,
        default: ()=>{
          return {
            line_one: '',
            line_two: '',
            city: '',
            county: '',
            post_code: '',
            country: 'United Kingdom',
          }
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      edit: {
        type: Boolean,
        default: false,
      },
      showExtraFields: {
        type: Boolean,
        default: true,
      },
    },
    mounted () {
      if(this.passedAddress!==null){
        this.postcode = this.passedAddress.post_code;
        if(['',undefined,null].indexOf(this.passedAddress.line_one)===-1){
          this.selectedAddress = this.passedAddress;
          this.manualAddress = true;
          this.setSelectedAddress(this.selectedAddress);
        }
      }
    },
    computed: {
      ...mapState("globals", ["searchedAddress"]),
    },
    watch: {
      passedAddress(newValue){
        this.selectedAddress = newValue;
      },
      selectedAddressId(newValue) {
        this.selectedAddress = this.allAddresses[newValue];
        this.selectedAddress.country = 'United Kingdom';
        this.manualAddress = true;
        this.setSelectedAddress(this.selectedAddress);
        this.$emit('addressSelected', this.selectedAddress);
      },
      edit(newValue) {
        if(newValue) {
          this.$emit('addressSelected', this.selectedAddress);
        }
      }
    },
    methods: {
      ...mapActions("globals", ["getAddressByCode","setSelectedAddress"]),
      async searchPostCode() {
        this.searched = false;
        this.manualAddress = false;
        this.postCodeSearchLoading = true;
        await this.getAddressByCode(this.postcode);
        this.searched = true;
        if(this.searchedAddress.results===undefined){
          this.allAddresses = [];
        }else{
          this.allAddresses = this.searchedAddress.results;
        }
        this.addressOptions = [];
        this.allAddresses.forEach((v,i)=>{
          this.addressOptions.push({text:v.summary_line,value:i});
        });
        this.postCodeSearchLoading = false;
      },
      checkManualAddress() {
        this.setSelectedAddress(this.selectedAddress);
        this.$emit('addressSelected', this.selectedAddress);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .postcode-icon {
    cursor: pointer;
  }
</style>
